import { call, fork, put, take } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { AutorisationROApi, CaptchaRestServiceApi } from '../../api/instances'

import {
  restPasswordForUser, restPasswordForUserInitiated,
  userLogin, userLoginInitiated,
  registerUserAccount, registerUserAccountInitiated,
  // loginAs, loginAsInitiated,
  confirmUserAccount, confirmUserAccountInitiated,
  changePasswordByUser, changePasswordByUserInitiated,
  setMessage,
  getNewCaptcha,
  getNewCaptchaInitiated,
  registerFailedUserAccountSuccess,
  registerFailedUserAccountError,
} from './user.actions'

import { Severity, EventType } from '@professocial/professocialTypes/types/messageTypes'
import {
  ChangePasswordByUserRequest, ConfirmUserAccountRequest,
  // LoginAsRequest,
  RegisterUserAccountRequest,
  RestPasswordForUserRequest,
  UserLoginRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/AutorisationROApi'
import { GetNewCaptchaRequest } from '@professocialApi/professocial-core-frontend-api/apis'

import {
  requestFailed,
  requestFinished,
  requestStarted
} from '@professocial/professocialCore/src/store/common/common.actions'
import i18n from 'i18next'

// login
const userLoginWorker = bindAsyncAction(userLogin)(
  function * (params: UserLoginRequest): any {
    return yield call([AutorisationROApi, AutorisationROApi.userLogin], params)
  },
)

function * watchUserLoginInitiated () {
  while (true) {
    const action: Action<UserLoginRequest> = yield take(userLoginInitiated)
    try {
      yield userLoginWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'Login fehlgeschlagen! Bitte überprüfen Sie Ihre Logindaten!',
        eventType: EventType.login,
      }))
    }
  }
}

// restPasswordForUser
const restPasswordForUserWorker = bindAsyncAction(restPasswordForUser)(
  function * (params: RestPasswordForUserRequest): any {
    return yield call([AutorisationROApi, AutorisationROApi.restPasswordForUser], params)
  },
)

function * watchRestPasswordForUserInitiated () {
  while (true) {
    const action: Action<RestPasswordForUserRequest> = yield take(restPasswordForUserInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield restPasswordForUserWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchRestPasswordForUserInitiated: ', e)
    }
  }
}

// registerUserAccount
const registerUserAccountWorker = bindAsyncAction(registerUserAccount)(
  function * (params: RegisterUserAccountRequest): any {
    return yield call([AutorisationROApi, AutorisationROApi.registerUserAccount], params)
  },
)

function * watchRegisterUserAccountInitiated (): Generator<any, void, any> {
  while (true) {
    const action: Action<RegisterUserAccountRequest> = yield take(registerUserAccountInitiated)
    try {
      const result = yield registerUserAccountWorker(action.payload)
      
      // Prüfen, ob die Antwort einen Fehlercode enthält
      if (result && result.errorCode) {
        // Bei Fehler
        yield put(registerFailedUserAccountError(result))
        yield put(setMessage({
          severity: Severity.error,
          message: 'messages:registerUserAccountError',
          eventType: EventType.registerUser,
        }))
      } else {
        // Bei Erfolg
        yield put(registerFailedUserAccountSuccess())
        yield put(setMessage({
          severity: Severity.success,
          message: 'messages:registerUserAccountSuccess',
          eventType: EventType.registerUser,
        }))
      }
    } catch (e) {
      console.error('error in watchRegisterUserAccountInitiated: ', e)
      yield put(registerFailedUserAccountError(e))
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:registerUserAccountError',
        eventType: EventType.registerUser,
      }))
    }
  }
}

// // loginAs
// const loginAsWorker = bindAsyncAction(loginAs)(
//   function * (params: LoginAsRequest) {
//     return yield call([AutorisationROApi, AutorisationROApi.loginAs], params)
//   },
// )
//
// function * watchLoginAsInitiated () {
//   while (true) {
//     const action: Action<LoginAsRequest> = yield take(loginAsInitiated)
//     try {
//       yield loginAsWorker(action.payload)
//     } catch (e) {
//       console.error('error in watchLoginAsInitiated: ', e)
//     }
//   }
// }

// confirmUserAccount
const confirmUserAccountWorker = bindAsyncAction(confirmUserAccount)(
  function * (params: ConfirmUserAccountRequest): any {
    return yield call([AutorisationROApi, AutorisationROApi.confirmUserAccount], params)
  },
)

function * watchConfirmUserAccountInitiated () {
  while (true) {
    const action: Action<ConfirmUserAccountRequest> = yield take(confirmUserAccountInitiated)
    try {
      yield confirmUserAccountWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:confirmUserAccountError',
        eventType: EventType.confirmAccount,
      }))
    }
  }
}

// changePasswordByUser
const changePasswordByUserWorker = bindAsyncAction(changePasswordByUser)(
  function * (params: ChangePasswordByUserRequest): any {
    return yield call([AutorisationROApi, AutorisationROApi.changePasswordByUser], params)
  },
)

function * watchChangePasswordByUserInitiated () {
  while (true) {
    const action: Action<ChangePasswordByUserRequest> = yield take(changePasswordByUserInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield changePasswordByUserWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))}
  }
}

// getNewCaptcha
const getNewCaptchaWorker = bindAsyncAction(getNewCaptcha)(
  function * (params: GetNewCaptchaRequest): any {
    return yield call([CaptchaRestServiceApi, CaptchaRestServiceApi.getNewCaptcha], params)
  },
)

function * watchGetNewCaptchaInitiated () {
  while (true) {
    const action: Action<GetNewCaptchaRequest> = yield take(getNewCaptchaInitiated)
    try {
      yield getNewCaptchaWorker(action.payload)
    } catch (e) {
      yield put(setMessage({
        severity: Severity.error,
        message: 'messages:getNewCaptchaError',
        eventType: EventType.upload,
      }))
    }
  }
}

export function * userSagas () {
  yield fork(watchUserLoginInitiated)
  yield fork(watchRestPasswordForUserInitiated)
  yield fork(watchRegisterUserAccountInitiated)
  // yield fork(watchLoginAsInitiated)
  yield fork(watchConfirmUserAccountInitiated)
  yield fork(watchChangePasswordByUserInitiated)
  yield fork(watchGetNewCaptchaInitiated)
}
